// tslint:disable
// This file is generated by buildArt script.
// Please don't edit it manually.
export var IdAssetBundleCalloutIcons;
(function (IdAssetBundleCalloutIcons) {
    IdAssetBundleCalloutIcons["AcreOutputIcn"] = "AcreOutputIcn";
    IdAssetBundleCalloutIcons["AlmondsIcn"] = "AlmondsIcn";
    IdAssetBundleCalloutIcons["AloeVeraIcn"] = "AloeVeraIcn";
    IdAssetBundleCalloutIcons["ApplesIcn"] = "ApplesIcn";
    IdAssetBundleCalloutIcons["BarleysIcn"] = "BarleysIcn";
    IdAssetBundleCalloutIcons["CabbageIcn"] = "CabbageIcn";
    IdAssetBundleCalloutIcons["CallOutBlue"] = "CallOutBlue";
    IdAssetBundleCalloutIcons["CallOutWhite"] = "CallOutWhite";
    IdAssetBundleCalloutIcons["CallOutYellow"] = "CallOutYellow";
    IdAssetBundleCalloutIcons["CheckIcn"] = "CheckIcn";
    IdAssetBundleCalloutIcons["CherriesIcn"] = "CherriesIcn";
    IdAssetBundleCalloutIcons["ChickenfeedIcn"] = "ChickenfeedIcn";
    IdAssetBundleCalloutIcons["CitrusFruitsIcn"] = "CitrusFruitsIcn";
    IdAssetBundleCalloutIcons["CocoaIcn"] = "CocoaIcn";
    IdAssetBundleCalloutIcons["CornIcn"] = "CornIcn";
    IdAssetBundleCalloutIcons["CowfeedIcn"] = "CowfeedIcn";
    IdAssetBundleCalloutIcons["DaisiesIcn"] = "DaisiesIcn";
    IdAssetBundleCalloutIcons["DandelionIcn"] = "DandelionIcn";
    IdAssetBundleCalloutIcons["DuckFeathersIcn"] = "DuckFeathersIcn";
    IdAssetBundleCalloutIcons["DuckfeedIcn"] = "DuckfeedIcn";
    IdAssetBundleCalloutIcons["EasterEggIcn"] = "EasterEggIcn";
    IdAssetBundleCalloutIcons["EasterfeedIcn"] = "EasterfeedIcn";
    IdAssetBundleCalloutIcons["EggsIcn"] = "EggsIcn";
    IdAssetBundleCalloutIcons["ExclamationMarkEventIcn"] = "ExclamationMarkEventIcn";
    IdAssetBundleCalloutIcons["ExclamationMarkIcn"] = "ExclamationMarkIcn";
    IdAssetBundleCalloutIcons["ExpandFarmIcn"] = "ExpandFarmIcn";
    IdAssetBundleCalloutIcons["ExpansionSaleIcn"] = "ExpansionSaleIcn";
    IdAssetBundleCalloutIcons["FertilizerIcn"] = "FertilizerIcn";
    IdAssetBundleCalloutIcons["GingerIcn"] = "GingerIcn";
    IdAssetBundleCalloutIcons["GoatCheeseIcn"] = "GoatCheeseIcn";
    IdAssetBundleCalloutIcons["GoatfeedIcn"] = "GoatfeedIcn";
    IdAssetBundleCalloutIcons["GoldflowersIcn"] = "GoldflowersIcn";
    IdAssetBundleCalloutIcons["HalloweenfeedIcn"] = "HalloweenfeedIcn";
    IdAssetBundleCalloutIcons["HoneyIcn"] = "HoneyIcn";
    IdAssetBundleCalloutIcons["HumusIcn"] = "HumusIcn";
    IdAssetBundleCalloutIcons["InactiveOutlinedIcn"] = "InactiveOutlinedIcn";
    IdAssetBundleCalloutIcons["JasmineIcn"] = "JasmineIcn";
    IdAssetBundleCalloutIcons["LambsLettuceIcn"] = "LambsLettuceIcn";
    IdAssetBundleCalloutIcons["LavenderIcn"] = "LavenderIcn";
    IdAssetBundleCalloutIcons["ManufactoryOutputIcn"] = "ManufactoryOutputIcn";
    IdAssetBundleCalloutIcons["MeadowOutputIcn"] = "MeadowOutputIcn";
    IdAssetBundleCalloutIcons["MilkIcn"] = "MilkIcn";
    IdAssetBundleCalloutIcons["NewHoneyIcn"] = "NewHoneyIcn";
    IdAssetBundleCalloutIcons["OlivesIcn"] = "OlivesIcn";
    IdAssetBundleCalloutIcons["PeachesIcn"] = "PeachesIcn";
    IdAssetBundleCalloutIcons["PigfeedIcn"] = "PigfeedIcn";
    IdAssetBundleCalloutIcons["PigsIcn"] = "PigsIcn";
    IdAssetBundleCalloutIcons["PrimeSaleIcn"] = "PrimeSaleIcn";
    IdAssetBundleCalloutIcons["PumpkinsIcn"] = "PumpkinsIcn";
    IdAssetBundleCalloutIcons["RosesIcn"] = "RosesIcn";
    IdAssetBundleCalloutIcons["RutabagaIcn"] = "RutabagaIcn";
    IdAssetBundleCalloutIcons["SheepWoolIcn"] = "SheepWoolIcn";
    IdAssetBundleCalloutIcons["TimeIcn"] = "TimeIcn";
    IdAssetBundleCalloutIcons["VanillaExtractIcn"] = "VanillaExtractIcn";
    IdAssetBundleCalloutIcons["VanillaIcn"] = "VanillaIcn";
    IdAssetBundleCalloutIcons["WaterIcn"] = "WaterIcn";
    IdAssetBundleCalloutIcons["WheatIcn"] = "WheatIcn";
    IdAssetBundleCalloutIcons["WildflowersIcn"] = "WildflowersIcn";
    IdAssetBundleCalloutIcons["WindmillOutputIcn"] = "WindmillOutputIcn";
    IdAssetBundleCalloutIcons["WinterfeedIcn"] = "WinterfeedIcn";
    IdAssetBundleCalloutIcons["XpIcn"] = "XpIcn";
})(IdAssetBundleCalloutIcons || (IdAssetBundleCalloutIcons = {}));



//////////////////
// WEBPACK FOOTER
// ./src/assetBundles/IdAssetBundleCalloutIcons.ts
// module id = 251
// module chunks = 3